// 1 fully dimmed no output
// 1-0 dimmed percentage
// 0 fully dimming (with activity)
// -1 fully dimmed (without activity)
/*
dim_profiles.loc['15':'19','mix zone/park'] = float(1)
dim_profiles.loc['20':'21','mix zone/park'] = float(0.7)
dim_profiles.loc['22':'23','mix zone/park'] = float(0.5)
dim_profiles.loc['00':'03','mix zone/park'] = 'B'
dim_profiles.loc['04','mix zone/park'] = float(0.5)
dim_profiles.loc['05':'08','mix zone/park'] = float(1)
*/



export const profile0 = {
	id: 'profile0',
	requireLogin: false,
	label: {
		de: 'Temporär hohe Intensität 1',
		en: 'Temporary high intensity 1',
		fr: 'Intensité temporairement élevée 1',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 2,
	AetoPro: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 0.7, 	activity: 0.7 }, // 19:00

		{ level: 0.7, 	activity: 0.7 }, // 20:00
		{ level: 0.3, 	activity: 0.3 }, // 21:00
		{ level: 0.3, 	activity: 0.3 }, // 22:00
		{ level: 0, 	activity: 0.3 }, // 23:00

		{ level: 0, 	activity: 0.3 },  // 00:00
		{ level: 0, 	activity: 0.3 },  // 01:00
		{ level: 0, 	activity: 0.3 },  // 02:00
		{ level: 0, 	activity: 0.3 },  // 03:00

		{ level: 0.3, 	activity: 0.3 }, // 04:00
		{ level: 0.3, 	activity: 0.3 }, // 05:00
		{ level: 0.7, 	activity: 0.7 }, // 06:00
		{ level: 0.7, 	activity: 0.7 }, // 07:00

		{ level: 0.7, 	activity: 0.7 }, // 08:00
		{ level: 0.7, 	activity: 0.7 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 0.7, 	activity: 0.7 }, // 19:00

		{ level: 0.7, 	activity: 0.7 }, // 20:00
		{ level: 0.3, 	activity: 0.3 }, // 21:00
		{ level: 0.3, 	activity: 0.3 }, // 22:00
		{ level: 0, 	activity: 0.3 }, // 23:00

		{ level: 0, 	activity: 0.3 },  // 00:00
		{ level: 0, 	activity: 0.3 },  // 01:00
		{ level: 0, 	activity: 0.3 },  // 02:00
		{ level: 0, 	activity: 0.3 },  // 03:00

		{ level: 0.3, 	activity: 0.3 }, // 04:00
		{ level: 0.3, 	activity: 0.3 }, // 05:00
		{ level: 0.7, 	activity: 0.7 }, // 06:00
		{ level: 0.7, 	activity: 0.7 }, // 07:00

		{ level: 0.7, 	activity: 0.7 }, // 08:00
		{ level: 0.7, 	activity: 0.7 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	]
};

export const profile1 = {
	id: 'profile1',
	requireLogin: false,
	label: {
		de: 'Temporär hohe Intensität 2',
		en: 'Temporary high intensity 2',
		fr: 'Intensité temporairement élevée 2',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 2,
	AetoPro: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 0.3, 	activity: 0.3 }, // 21:00
		{ level: 0.3, 	activity: 0.3 }, // 22:00
		{ level: 0, 	activity: 0.3 }, // 23:00

		{ level: 0, 	activity: 0.3 },  // 00:00
		{ level: 0, 	activity: 0.3 },  // 01:00
		{ level: 0, 	activity: 0.3 },  // 02:00
		{ level: 0, 	activity: 0.3 },  // 03:00

		{ level: 0.3, 	activity: 0.3 }, // 04:00
		{ level: 0.3, 	activity: 0.3 }, // 05:00
		{ level: 0.7, 	activity: 0.7 }, // 06:00
		{ level: 0.7, 	activity: 0.7 }, // 07:00

		{ level: 0.7, 	activity: 0.7 }, // 08:00
		{ level: 0.7, 	activity: 0.7 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 0.3, 	activity: 0.3 }, // 21:00
		{ level: 0.3, 	activity: 0.3 }, // 22:00
		{ level: 0, 	activity: 0.3 }, // 23:00

		{ level: 0, 	activity: 0.3 },  // 00:00
		{ level: 0, 	activity: 0.3 },  // 01:00
		{ level: 0, 	activity: 0.3 },  // 02:00
		{ level: 0, 	activity: 0.3 },  // 03:00

		{ level: 0.3, 	activity: 0.3 }, // 04:00
		{ level: 0.3, 	activity: 0.3 }, // 05:00
		{ level: 0.7, 	activity: 0.7 }, // 06:00
		{ level: 0.7, 	activity: 0.7 }, // 07:00

		{ level: 0.7, 	activity: 0.7 }, // 08:00
		{ level: 0.7, 	activity: 0.7 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	]
};

export const profile2 = {
	id: 'profile2',
	requireLogin: false,
	label: {
		de: 'Temporär hohe Intensität 3',
		en: 'Temporary high intensity 3',
		fr: 'Intensité temporairement élevée 3',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 1.2,
	AetoPro: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 1, 	activity: 1 }, // 21:00
		{ level: 1, 	activity: 1 }, // 22:00
		{ level: 0, 	activity: 0.5 }, // 23:00

		{ level: 0, 	activity: 0.5 },  // 00:00
		{ level: 0, 	activity: 0.5 },  // 01:00
		{ level: 0, 	activity: 0.5 },  // 02:00
		{ level: 0, 	activity: 0.5 },  // 03:00

		{ level: 0, 	activity: 0.5 }, // 04:00
		{ level: 0, 	activity: 0.5 }, // 05:00
		{ level: 1, 	activity: 1 }, // 06:00
		{ level: 1, 	activity: 1 }, // 07:00

		{ level: 1, 	activity: 1 }, // 08:00
		{ level: 1, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 1, 	activity: 1 }, // 21:00
		{ level: 1, 	activity: 1 }, // 22:00
		{ level: 0, 	activity: 0.5 }, // 23:00

		{ level: 0, 	activity: 0.5 },  // 00:00
		{ level: 0, 	activity: 0.5 },  // 01:00
		{ level: 0, 	activity: 0.5 },  // 02:00
		{ level: 0, 	activity: 0.5 },  // 03:00

		{ level: 0, 	activity: 0.5 }, // 04:00
		{ level: 0, 	activity: 0.5 }, // 05:00
		{ level: 1, 	activity: 1 }, // 06:00
		{ level: 1, 	activity: 1 }, // 07:00

		{ level: 1, 	activity: 1 }, // 08:00
		{ level: 1, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	]
};



export const profile3 = {
	id: 'profile3',
	requireLogin: false,
	label: {
		de: 'Kontinuierliches Licht 1',
		en: 'Continuous light 1',
		fr: 'Lumière continue 1',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 2,
	AetoPro: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 0.7, 	activity: 0.7 }, // 20:00
		{ level: 0.7, 	activity: 0.7 }, // 21:00
		{ level: 0.7, 	activity: 0.7 }, // 22:00
		{ level: 0.7, 	activity: 0.7 }, // 23:00

		{ level: 0.7, 	activity: 0.7 },  // 00:00
		{ level: 0.3, 	activity: 0.3 },  // 01:00
		{ level: 0.3, 	activity: 0.3 },  // 02:00
		{ level: 0.3, 	activity: 0.3 },  // 03:00

		{ level: 0.3, 	activity: 0.3 }, // 04:00
		{ level: 0.7, 	activity: 0.7 }, // 05:00
		{ level: 0.7, 	activity: 0.7 }, // 06:00
		{ level: 0.7, 	activity: 0.7 }, // 07:00

		{ level: 0.7, 	activity: 0.7 }, // 08:00
		{ level: 0.7, 	activity: 0.7 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 0.25, 	activity: 0.25 }, // 20:00
		{ level: 0.25, 	activity: 0.25 }, // 21:00
		{ level: 0.25, 	activity: 0.25 }, // 22:00
		{ level: 0.25, 	activity: 0.25 }, // 23:00

		{ level: 0.25, 	activity: 0.25 },  // 00:00
		{ level: 0.25, 	activity: 0.25 },  // 01:00
		{ level: 0.25, 	activity: 0.25 },  // 02:00
		{ level: 0.25, 	activity: 0.25 },  // 03:00

		{ level: 0.25, 	activity: 0.25 }, // 04:00
		{ level: 0.25, 	activity: 0.25 }, // 05:00
		{ level: 0.25, 	activity: 0.25 }, // 06:00
		{ level: 0.25, 	activity: 0.25 }, // 07:00

		{ level: 0.25, 	activity: 0.25 }, // 08:00
		{ level: 0.25, 	activity: 0.25 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	]
};

export const profile4 = {
	id: 'profile4',
	requireLogin: false,
	label: {
		de: 'Kontinuierliches Licht 2',
		en: 'Continuous light 2',
		fr: 'Lumière continue 2',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 2,
	AetoPro: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 1, 	activity: 1 }, // 21:00
		{ level: 0.3, 	activity: 0.3 }, // 22:00
		{ level: 0.3, 	activity: 0.3 }, // 23:00

		{ level: 0.3, 	activity: 0.3 },  // 00:00
		{ level: 0.3, 	activity: 0.3 },  // 01:00
		{ level: 0.3, 	activity: 0.3 },  // 02:00
		{ level: 0.3, 	activity: 0.3 },  // 03:00

		{ level: 1, 	activity: 1 }, // 04:00
		{ level: 1, 	activity: 1 }, // 05:00
		{ level: 1, 	activity: 1 }, // 06:00
		{ level: 1, 	activity: 1 }, // 07:00

		{ level: 1, 	activity: 1 }, // 08:00
		{ level: 1, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 1, 	activity: 1 }, // 21:00
		{ level: 0.25, 	activity: 0.25 }, // 22:00
		{ level: 0.25, 	activity: 0.25 }, // 23:00

		{ level: 0.25, 	activity: 0.25 },  // 00:00
		{ level: 0.25, 	activity: 0.25 },  // 01:00
		{ level: 0.25, 	activity: 0.25 },  // 02:00
		{ level: 0.25, 	activity: 0.25 },  // 03:00

		{ level: 1, 	activity: 1 }, // 04:00
		{ level: 1, 	activity: 1 }, // 05:00
		{ level: 1, 	activity: 1 }, // 06:00
		{ level: 1, 	activity: 1 }, // 07:00

		{ level: 1, 	activity: 1 }, // 08:00
		{ level: 1, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	]
};

export const profile5 = {
	id: 'profile5',
	requireLogin: false,
	label: {
		de: 'Kontinuierliches Licht 3',
		en: 'Continuous light 3',
		fr: 'Lumière continue 3',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 1,
	AetoPro: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 1, 	activity: 1 }, // 21:00
		{ level: 1, 	activity: 1 }, // 22:00
		{ level: 1, 	activity: 1 }, // 23:00

		{ level: 1, 	activity: 1 },  // 00:00
		{ level: 1, 	activity: 1 },  // 01:00
		{ level: 1, 	activity: 1 },  // 02:00
		{ level: 1, 	activity: 1 },  // 03:00

		{ level: 1, 	activity: 1 }, // 04:00
		{ level: 1, 	activity: 1 }, // 05:00
		{ level: 1, 	activity: 1 }, // 06:00
		{ level: 1, 	activity: 1 }, // 07:00

		{ level: 1, 	activity: 1 }, // 08:00
		{ level: 1, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 1, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 1, 	activity: 1 }, // 21:00
		{ level: 1, 	activity: 1 }, // 22:00
		{ level: 1, 	activity: 1 }, // 23:00

		{ level: 1, 	activity: 1 },  // 00:00
		{ level: 1, 	activity: 1 },  // 01:00
		{ level: 1, 	activity: 1 },  // 02:00
		{ level: 1, 	activity: 1 },  // 03:00

		{ level: 1, 	activity: 1 }, // 04:00
		{ level: 1, 	activity: 1 }, // 05:00
		{ level: 1, 	activity: 1 }, // 06:00
		{ level: 1, 	activity: 1 }, // 07:00

		{ level: 1, 	activity: 1 }, // 08:00
		{ level: 1, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	]
};



export const profile6 = {
	id: 'profile6',
	requireLogin: true,
	label: {
		de: 'Motion 1',
		en: 'Motion 1',
		fr: 'Motion 1',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 1,
	AetoPro: [
		{ level: 0, 	activity: 1 }, // 12:00
		{ level: 0, 	activity: 1 }, // 13:00
		{ level: 0, 	activity: 1 }, // 14:00
		{ level: 0, 	activity: 1 }, // 15:00

		{ level: 0, 	activity: 1 }, // 16:00
		{ level: 0, 	activity: 1 }, // 17:00
		{ level: 0, 	activity: 1 }, // 18:00
		{ level: 0, 	activity: 1 }, // 19:00

		{ level: 0, 	activity: 1 }, // 20:00
		{ level: 0, 	activity: 1 }, // 21:00
		{ level: 0, 	activity: 1 }, // 22:00
		{ level: 0, 	activity: 1 }, // 23:00

		{ level: 0, 	activity: 1 },  // 00:00
		{ level: 0, 	activity: 1 },  // 01:00
		{ level: 0, 	activity: 1 },  // 02:00
		{ level: 0, 	activity: 1 },  // 03:00

		{ level: 0, 	activity: 1 }, // 04:00
		{ level: 0, 	activity: 1 }, // 05:00
		{ level: 0, 	activity: 1 }, // 06:00
		{ level: 0, 	activity: 1 }, // 07:00

		{ level: 0, 	activity: 1 }, // 08:00
		{ level: 0, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 1 }, // 10:00
		{ level: 0, 	activity: 1 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 1 }, // 12:00
		{ level: 0, 	activity: 1 }, // 13:00
		{ level: 0, 	activity: 1 }, // 14:00
		{ level: 0, 	activity: 1 }, // 15:00

		{ level: 0, 	activity: 1 }, // 16:00
		{ level: 0, 	activity: 1 }, // 17:00
		{ level: 0, 	activity: 1 }, // 18:00
		{ level: 0, 	activity: 1 }, // 19:00

		{ level: 0, 	activity: 1 }, // 20:00
		{ level: 0, 	activity: 1 }, // 21:00
		{ level: 0, 	activity: 1 }, // 22:00
		{ level: 0, 	activity: 1 }, // 23:00

		{ level: 0, 	activity: 1 },  // 00:00
		{ level: 0, 	activity: 1 },  // 01:00
		{ level: 0, 	activity: 1 },  // 02:00
		{ level: 0, 	activity: 1 },  // 03:00

		{ level: 0, 	activity: 1 }, // 04:00
		{ level: 0, 	activity: 1 }, // 05:00
		{ level: 0, 	activity: 1 }, // 06:00
		{ level: 0, 	activity: 1 }, // 07:00

		{ level: 0, 	activity: 1 }, // 08:00
		{ level: 0, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 1 }, // 10:00
		{ level: 0, 	activity: 1 }, // 11:00
	]
};

export const profile7 = {
	id: 'profile7',
	requireLogin: true,
	label: {
		de: 'Motion 3',
		en: 'Motion 3',
		fr: 'Motion 3',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 3,
	AetoPro: [
		{ level: 0.2, 	activity: 1 }, // 12:00
		{ level: 0.2, 	activity: 1 }, // 13:00
		{ level: 0.2, 	activity: 1 }, // 14:00
		{ level: 0.2, 	activity: 1 }, // 15:00

		{ level: 0.2, 	activity: 1 }, // 16:00
		{ level: 0.2, 	activity: 1 }, // 17:00
		{ level: 0.2, 	activity: 1 }, // 18:00
		{ level: 0.2, 	activity: 1 }, // 19:00

		{ level: 0.2, 	activity: 1 }, // 20:00
		{ level: 0.2, 	activity: 1 }, // 21:00
		{ level: 0.2, 	activity: 1 }, // 22:00
		{ level: 0.2, 	activity: 1 }, // 23:00

		{ level: 0.2, 	activity: 1 },  // 00:00
		{ level: 0.2, 	activity: 1 },  // 01:00
		{ level: 0.2, 	activity: 1 },  // 02:00
		{ level: 0.2, 	activity: 1 },  // 03:00

		{ level: 0.2, 	activity: 1 }, // 04:00
		{ level: 0.2, 	activity: 1 }, // 05:00
		{ level: 0.2, 	activity: 1 }, // 06:00
		{ level: 0.2, 	activity: 1 }, // 07:00

		{ level: 0.2, 	activity: 1 }, // 08:00
		{ level: 0.2, 	activity: 1 }, // 09:00
		{ level: 0.2, 	activity: 1 }, // 10:00
		{ level: 0.2, 	activity: 1 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 0 }, // 12:00
		{ level: 0, 	activity: 0 }, // 13:00
		{ level: 0, 	activity: 0 }, // 14:00
		{ level: 0, 	activity: 0 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 1, 	activity: 1 }, // 19:00

		{ level: 1, 	activity: 1 }, // 20:00
		{ level: 1, 	activity: 1 }, // 21:00
		{ level: 1, 	activity: 1 }, // 22:00
		{ level: 1, 	activity: 1 }, // 23:00

		{ level: 1, 	activity: 1 },  // 00:00
		{ level: 1, 	activity: 1 },  // 01:00
		{ level: 1, 	activity: 1 },  // 02:00
		{ level: 1, 	activity: 1 },  // 03:00

		{ level: 1, 	activity: 1 }, // 04:00
		{ level: 1, 	activity: 1 }, // 05:00
		{ level: 1, 	activity: 1 }, // 06:00
		{ level: 1, 	activity: 1 }, // 07:00

		{ level: 0, 	activity: 0 }, // 08:00
		{ level: 0, 	activity: 0 }, // 09:00
		{ level: 0, 	activity: 0 }, // 10:00
		{ level: 0, 	activity: 0 }, // 11:00
	]
};

export const profile8 = {
	id: 'profile8',
	requireLogin: true,
	label: {
		de: 'Motion 2',
		en: 'Motion 2',
		fr: 'Motion 2',
	},
	description: {
		de: '',
		en: '',
		fr: '',
	},
	minPower: 3,
	AetoPro: [
		{ level: 0.2, 	activity: 1 }, // 12:00
		{ level: 0.2, 	activity: 1 }, // 13:00
		{ level: 0.2, 	activity: 1 }, // 14:00
		{ level: 0.2, 	activity: 1 }, // 15:00

		{ level: 0.2, 	activity: 1 }, // 16:00
		{ level: 0.2, 	activity: 1 }, // 17:00
		{ level: 0.2, 	activity: 1 }, // 18:00
		{ level: 0.2, 	activity: 1 }, // 19:00

		{ level: 0.2, 	activity: 1 }, // 20:00
		{ level: 0.2, 	activity: 1 }, // 21:00
		{ level: 0, 	activity: 1 }, // 22:00
		{ level: 0, 	activity: 1 }, // 23:00

		{ level: 0, 	activity: 1 },  // 00:00
		{ level: 0, 	activity: 1 },  // 01:00
		{ level: 0, 	activity: 1 },  // 02:00
		{ level: 0, 	activity: 1 },  // 03:00

		{ level: 0, 	activity: 1 }, // 04:00
		{ level: 0, 	activity: 1 }, // 05:00
		{ level: 0.2, 	activity: 1 }, // 06:00
		{ level: 0.2, 	activity: 1 }, // 07:00

		{ level: 0.2, 	activity: 1 }, // 08:00
		{ level: 0.2, 	activity: 1 }, // 09:00
		{ level: 0.2, 	activity: 1 }, // 10:00
		{ level: 0.2, 	activity: 1 }, // 11:00
	],
	AetoBasic: [
		{ level: 0, 	activity: 1 }, // 12:00
		{ level: 0, 	activity: 1 }, // 13:00
		{ level: 0, 	activity: 1 }, // 14:00
		{ level: 0, 	activity: 1 }, // 15:00

		{ level: 1, 	activity: 1 }, // 16:00
		{ level: 1, 	activity: 1 }, // 17:00
		{ level: 1, 	activity: 1 }, // 18:00
		{ level: 0.5, 	activity: 1 }, // 19:00

		{ level: 0.5, 	activity: 1 }, // 20:00
		{ level: 0.5, 	activity: 1 }, // 21:00
		{ level: 0.5, 	activity: 1 }, // 22:00
		{ level: 0, 	activity: 1 }, // 23:00

		{ level: 0, 	activity: 1 },  // 00:00
		{ level: 0, 	activity: 1 },  // 01:00
		{ level: 0, 	activity: 1 },  // 02:00
		{ level: 0, 	activity: 1 },  // 03:00

		{ level: 0.5, 	activity: 1 }, // 04:00
		{ level: 0.5, 	activity: 1 }, // 05:00
		{ level: 0.5, 	activity: 1 }, // 06:00
		{ level: 0.5, 	activity: 1 }, // 07:00

		{ level: 0, 	activity: 1 }, // 08:00
		{ level: 0, 	activity: 1 }, // 09:00
		{ level: 0, 	activity: 1 }, // 10:00
		{ level: 0, 	activity: 1 }, // 11:00
	]
};


export const solarDimmProfileOptions = [
	profile0,
	profile1,
	profile2,

	profile3,
	profile4,
	profile5,

	profile6,
	profile8,
	profile7,
];
